import { render } from "./KioskLoginView.vue?vue&type=template&id=a4ecc314&scoped=true"
import script from "./KioskLoginView.vue?vue&type=script&lang=js"
export * from "./KioskLoginView.vue?vue&type=script&lang=js"

import "./KioskLoginView.vue?vue&type=style&index=0&id=a4ecc314&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4ecc314"]])

export default __exports__